import { CustomTextField } from '@atbay/component-lib'
import { FormField } from '@core/modules/integrations/integrations'
import { Controller, useFormContext } from 'react-hook-form'
import { ControlWrapper, Wrapper } from './Form.styles'
import Typography from '@/ui/components/typography'
import { useState } from 'react'

const Form = ({ formStructure }: { formStructure: FormField[] }) => {
    const { formState, control } = useFormContext()
    const [error, setError] = useState<string | null>()

    if (error) {
        return <Typography variant="xs-regular">{error}</Typography>
    }

    return (
        <Wrapper>
            <form>
                {formStructure.map((dynamicField: FormField) => {
                    return (
                        <ControlWrapper key={dynamicField.label}>
                            <Controller
                                name={dynamicField.label}
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => {
                                    return (
                                        <CustomTextField
                                            inputType={dynamicField.type}
                                            label={dynamicField.name}
                                            textValue={field.value}
                                            onChange={field.onChange}
                                            accessibilityId={field.name}
                                            error={
                                                !!formState.errors?.[field.name]
                                            }
                                        />
                                    )
                                }}
                            />
                        </ControlWrapper>
                    )
                })}
            </form>
        </Wrapper>
    )
}

export default Form
